// src/components/common/Sidebar.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { getPopularPrograms } from '../../data/supportPrograms';
import { keyFigures2026 } from '../../data/changes2026';
import { categories } from '../../data/categories';
import SideBanner from '../ads/SideBanner';
import CoupangSideBanner from '../affiliate/CoupangSideBanner';
import Icon from './Icon';

interface SidebarProps {
    /** 인기 지원금을 특정 분야로 한정 */
    category?: string;
    /** 랭킹 위젯 제목 */
    rankTitle?: string;
}

const formatViews = (n: number) => (n >= 10000 ? `${(n / 10000).toFixed(1)}만` : n.toLocaleString());

const Sidebar: React.FC<SidebarProps> = ({ category = 'all', rankTitle }) => {
    const popular = getPopularPrograms(10, category);

    return (
        <aside className="gh-aside">
            {/* 인기 지원금 TOP 10 */}
            <section className="gh-widget">
                <div className="gh-widget__head">
                    <h2 className="gh-widget__title">
                        <Icon name="chart" size={17} />
                        {rankTitle ?? '많이 찾는 지원금 TOP 10'}
                    </h2>
                    <Link to="/search" className="gh-widget__more">
                        전체
                        <Icon name="chevronRight" size={12} strokeWidth={2.4} />
                    </Link>
                </div>
                <div className="gh-widget__body">
                    <ol className="gh-rank">
                        {popular.map((p, i) => (
                            <li key={p.id}>
                                <Link to={`/program/${p.slug}`} className="gh-rank__item">
                                    <span className="gh-rank__num">{i + 1}</span>
                                    <span className="gh-rank__title">{p.title}</span>
                                    <span className="gh-rank__views">
                                        <Icon name="eye" size={12} />
                                        {formatViews(p.views)}
                                    </span>
                                </Link>
                            </li>
                        ))}
                    </ol>
                </div>
            </section>

            {/* 2026 핵심 지표 */}
            <section className="gh-widget">
                <div className="gh-widget__head">
                    <h2 className="gh-widget__title">
                        <Icon name="coin" size={17} />
                        2026년 핵심 기준
                    </h2>
                    <Link to="/2026" className="gh-widget__more">
                        더보기
                        <Icon name="chevronRight" size={12} strokeWidth={2.4} />
                    </Link>
                </div>
                <div className="gh-widget__body">
                    <div className="gh-rank">
                        {keyFigures2026.map(f => (
                            <div className="gh-rank__item" key={f.label} style={{ cursor: 'default' }}>
                                <span className="gh-rank__title" style={{ whiteSpace: 'normal' }}>
                                    {f.label}
                                </span>
                                <b style={{ fontSize: 13, color: 'var(--blue-700)', flexShrink: 0 }}>
                                    {f.value}
                                </b>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* 자사 서비스 배너 */}
            <SideBanner />

            {/* 쿠팡 민생지원 배너 (제휴) */}
            <CoupangSideBanner />

            {/* 분야 바로가기 */}
            <section className="gh-widget">
                <div className="gh-widget__head">
                    <h2 className="gh-widget__title">
                        <Icon name="grid" size={17} />
                        분야별 바로가기
                    </h2>
                </div>
                <div className="gh-widget__body">
                    <div className="gh-quick">
                        {categories.slice(1).map(c => (
                            <Link key={c.id} to={c.path} className="gh-quick__item">
                                <Icon name={c.icon} size={20} />
                                {c.shortName}
                            </Link>
                        ))}
                    </div>
                </div>
            </section>

            {/* 2027 전망 배너 */}
            <section className="gh-note">
                <h2 className="gh-note__title">2027년 정부지원금 전망</h2>
                <p className="gh-note__desc">
                    총지출 820조 9천억원 규모의 2027년 예산안이 발표됐습니다.
                    혼인·출산지원금 신설, 청년예산 43.3조원 등 달라지는 내용을 정리했습니다.
                </p>
                <Link to="/2027" className="gh-note__btn">
                    전망 확인하기
                    <Icon name="arrowRight" size={15} strokeWidth={2.2} />
                </Link>
            </section>
        </aside>
    );
};

export default Sidebar;
